import { select, tabBar } from 'material-components-web/index';

const config = {
    selectors: {
        searchResults: '.eifu-search-results',
        tabBar: '.eifu-search-results__tab-bar',
        tab: '.eifu-search-results__tab',
        tabBody: '.eifu-search-results__tab-body',
        select: '.eifu-search-results__select',
    },
    classNames: {
        tabBodyActive: 'eifu-search-results__tab-body--active',
    },
};

function init() {
    $(config.selectors.searchResults).each((i, el) => {
        const $searchResults = $(el);
        initSearchResults($searchResults);
    });
}

function initSearchResults($searchResults) {
    initTabsAndSelect($searchResults);
}

function initTabsAndSelect($searchResults) {
    const $tabBar = $searchResults.find(config.selectors.tabBar);
    const $tabBodies = $searchResults.find(config.selectors.tabBody);
    const $select = $searchResults.find(config.selectors.select);

    if (!$tabBar.length) {
        return;
    }

    function handleDocumentTypeChange(index) {
        const $tabBody = $($tabBodies[index]);

        if (!$tabBody.length) {
            return;
        }

        // hide all other than activated tab body
        $tabBodies.each((i, el) => {
            if (!$tabBody.is(el)) {
                const $currentTabBody = $(el);
                hideTabBody($currentTabBody);
            }
        });

        // show activated tab body
        showTabBody($tabBody);
    }

    const mdcTabBar = new tabBar.MDCTabBar($tabBar[0]);
    const mdcSelect = new select.MDCSelect($select[0]);
    const initialIndex = 0;

    mdcTabBar.activateTab(initialIndex);
    mdcSelect.selectedIndex = initialIndex;

    mdcTabBar.listen('MDCTabBar:activated', (e) => {
        const { detail: { index } } = e;

        // synchronize mobile select
        mdcSelect.selectedIndex = index;
        handleDocumentTypeChange(index);
    });

    mdcSelect.listen('MDCSelect:change', (e) => {
        const { detail: { index } } = e;

        // console.log('select triggered');
        // synchronize desktop tabs
        mdcTabBar.activateTab(index);
        handleDocumentTypeChange(index);
    });
}

function showTabBody($tabBody) {
    $tabBody.addClass(config.classNames.tabBodyActive);
}

function hideTabBody($tabBody) {
    $tabBody.removeClass(config.classNames.tabBodyActive);
}

if (document.querySelectorAll('.eifu').length > 0) {
    init();
}
